document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initAcordeones();
  initCuentaAtras();
  initGaleriaProducto();
  initPacks();
  initStickyCta();
  initVisitantes();
  initCarrusel('[data-pm-carrusel]');
  initResenasGrandes();
});

function initReveal() {
  var elementos = document.querySelectorAll('.pm-reveal');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('pm-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pm-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  elementos.forEach(function (el) { observer.observe(el); });
}

function initAcordeones() {
  var grupos = document.querySelectorAll('[data-pm-acordeon]');
  if (!grupos.length) return;
  grupos.forEach(function (grupo) {
    var items = grupo.querySelectorAll('.pm-acordeon__item');
    items.forEach(function (item) {
      var boton = item.querySelector('.pm-acordeon__pregunta');
      var respuesta = item.querySelector('.pm-acordeon__respuesta');
      if (!boton || !respuesta) return;
      boton.addEventListener('click', function () {
        var abierto = item.getAttribute('data-abierto') === 'true';
        items.forEach(function (otro) {
          otro.setAttribute('data-abierto', 'false');
          var r = otro.querySelector('.pm-acordeon__respuesta');
          if (r) r.style.maxHeight = null;
        });
        if (!abierto) {
          item.setAttribute('data-abierto', 'true');
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        }
      });
    });
  });
}

function initCuentaAtras() {
  var elementos = document.querySelectorAll('[data-pm-cuenta-atras]');
  if (!elementos.length) return;

  function pad(n) { return String(n).padStart(2, '0'); }

  elementos.forEach(function (el) {
    var horas = parseFloat(el.getAttribute('data-duracion-horas'));
    if (!horas || horas <= 0) return;
    var duracionMs = horas * 3600 * 1000;
    var clave = 'pm-cuenta-inicio';

    var partes = {
      h: el.querySelector('[data-parte="h"]'),
      m: el.querySelector('[data-parte="m"]'),
      s: el.querySelector('[data-parte="s"]')
    };

    function obtenerInicio() {
      var guardado = null;
      try {
        guardado = parseInt(localStorage.getItem(clave), 10);
      } catch (e) {
        return Date.now();
      }
      var ahora = Date.now();
      if (!guardado || isNaN(guardado) || (ahora - guardado) >= duracionMs) {
        guardado = ahora;
        try { localStorage.setItem(clave, String(guardado)); } catch (e) {}
      }
      return guardado;
    }

    var inicio = obtenerInicio();

    function tick() {
      var ahora = Date.now();
      if (ahora - inicio >= duracionMs) {
        inicio = ahora;
        try { localStorage.setItem(clave, String(inicio)); } catch (e) {}
      }
      var restanteMs = duracionMs - (ahora - inicio);
      var segundos = Math.ceil(restanteMs / 1000);

      var horasRestantes = Math.floor(segundos / 3600);
      var minutosRestantes = Math.floor((segundos % 3600) / 60);
      var segsRestantes = segundos % 60;

      if (partes.h) partes.h.textContent = pad(horasRestantes);
      if (partes.m) partes.m.textContent = pad(minutosRestantes);
      if (partes.s) partes.s.textContent = pad(segsRestantes);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-pm-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-pm-galeria-principal] img');
  var miniaturas = galeria.querySelectorAll('[data-pm-galeria-miniatura]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (full) {
        principal.setAttribute('src', full);
        principal.setAttribute('srcset', '');
        principal.setAttribute('alt', alt);
      }
      miniaturas.forEach(function (m) { m.setAttribute('data-activa', 'false'); });
      mini.setAttribute('data-activa', 'true');
    });
  });
}

function initPacks() {
  var contenedor = document.querySelector('[data-pm-packs]');
  if (!contenedor) return;
  var packs = contenedor.querySelectorAll('[data-pm-pack]');
  var inputVariante = document.querySelector('[data-pm-variant-input]');
  var precioActual = document.querySelector('[data-pm-precio-actual]');
  var precioComparado = document.querySelector('[data-pm-precio-comparado]');
  var stickyPrecio = document.querySelector('[data-pm-sticky-precio]');
  var botonComprar = document.querySelector('[data-pm-boton-comprar]');
  var botonStickyComprar = document.querySelector('[data-pm-sticky-comprar]');
  var gruposTallas = document.querySelectorAll('[data-pack-tallas]');

  function actualizarGruposTallas(indicePack) {
    gruposTallas.forEach(function (grupo) {
      var esActivo = grupo.getAttribute('data-pack-tallas') === String(indicePack);
      grupo.setAttribute('data-visible', esActivo ? 'true' : 'false');
      grupo.querySelectorAll('select').forEach(function (select) {
        select.disabled = !esActivo;
      });
    });
  }

  packs.forEach(function (pack) {
    pack.addEventListener('click', function () {
      packs.forEach(function (p) { p.setAttribute('data-activo', 'false'); });
      pack.setAttribute('data-activo', 'true');

      var variantId = pack.getAttribute('data-variant-id');
      var precio = pack.getAttribute('data-precio');
      var comparado = pack.getAttribute('data-comparado');
      var disponible = pack.getAttribute('data-disponible') === 'true';
      var indicePack = pack.getAttribute('data-pack-index');

      if (indicePack) actualizarGruposTallas(indicePack);
      if (inputVariante && variantId) inputVariante.value = variantId;
      if (precioActual && precio) precioActual.textContent = precio;
      if (precioComparado) {
        if (comparado) {
          precioComparado.textContent = comparado;
          precioComparado.style.display = '';
        } else {
          precioComparado.style.display = 'none';
        }
      }
      if (stickyPrecio && precio) stickyPrecio.textContent = precio;

      [botonComprar, botonStickyComprar].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !disponible;
        btn.textContent = disponible ? btn.getAttribute('data-texto-disponible') : btn.getAttribute('data-texto-agotado');
      });
    });
  });
}

function initStickyCta() {
  var sticky = document.querySelector('[data-pm-sticky-cta]');
  if (!sticky) return;
  var botonPrincipal = document.querySelector('[data-pm-boton-comprar]');
  var footer = document.querySelector('footer');
  if (!botonPrincipal) return;

  var botonVisible = false;
  var footerVisible = false;

  function actualizar() {
    sticky.setAttribute('data-visible', (!botonVisible && !footerVisible) ? 'true' : 'false');
  }

  var obsBoton = new IntersectionObserver(function (entries) {
    botonVisible = entries[0].isIntersecting;
    actualizar();
  }, { threshold: 0.1 });
  obsBoton.observe(botonPrincipal);

  if (footer) {
    var obsFooter = new IntersectionObserver(function (entries) {
      footerVisible = entries[0].isIntersecting;
      actualizar();
    }, { threshold: 0.01 });
    obsFooter.observe(footer);
  }
}

function initVisitantes() {
  var elementos = document.querySelectorAll('[data-pm-en-directo]');
  if (!elementos.length) return;
  elementos.forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 8;
    var max = parseInt(el.getAttribute('data-max'), 10) || 34;
    var numero = Math.floor(Math.random() * (max - min + 1)) + min;
    var span = el.querySelector('[data-pm-en-directo-numero]');
    if (span) span.textContent = numero;
  });
}

function initCarrusel(selector) {
  var carruseles = document.querySelectorAll(selector);
  if (!carruseles.length) return;

  carruseles.forEach(function (wrap) {
    var pista = wrap.querySelector('[data-pm-carrusel-pista]');
    if (!pista) return;
    var puntosCont = wrap.querySelector('[data-pm-carrusel-puntos]');
    var prevBtn = wrap.querySelector('[data-pm-carrusel-anterior]');
    var nextBtn = wrap.querySelector('[data-pm-carrusel-siguiente]');
    var items = Array.prototype.slice.call(pista.children);

    if (puntosCont && items.length > 1) {
      items.forEach(function (item, i) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'pm-carrusel__punto';
        punto.setAttribute('data-activo', i === 0 ? 'true' : 'false');
        punto.addEventListener('click', function () {
          items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        puntosCont.appendChild(punto);
      });
    }

    function actualizarPuntos() {
      if (!puntosCont) return;
      var puntos = puntosCont.querySelectorAll('.pm-carrusel__punto');
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var activo = 0;
      var mejorDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs((item.offsetLeft + item.clientWidth / 2) - centro);
        if (dist < mejorDist) { mejorDist = dist; activo = i; }
      });
      puntos.forEach(function (p, i) { p.setAttribute('data-activo', i === activo ? 'true' : 'false'); });
    }

    var scrollTimeout;
    pista.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(actualizarPuntos, 100);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () {
      pista.scrollBy({ left: -pista.clientWidth * 0.8, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      pista.scrollBy({ left: pista.clientWidth * 0.8, behavior: 'smooth' });
    });

    var isDown = false, startX, scrollLeftInicio;
    pista.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - pista.offsetLeft;
      scrollLeftInicio = pista.scrollLeft;
    });
    window.addEventListener('mouseup', function () { isDown = false; });
    pista.addEventListener('mouseleave', function () { isDown = false; });
    pista.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - pista.offsetLeft;
      var walk = (x - startX) * 1.2;
      pista.scrollLeft = scrollLeftInicio - walk;
    });
  });
}

function initResenasGrandes() {
  var contenedor = document.querySelector('[data-pm-resenas-grid]');
  if (!contenedor) return;
  var cards = contenedor.querySelectorAll('.pm-resena-card');
  var botonMas = document.querySelector('[data-pm-resenas-mas]');
  var botonMenos = document.querySelector('[data-pm-resenas-menos]');
  var porPagina = 8;
  var visibles = porPagina;

  function mostrar() {
    cards.forEach(function (card, i) {
      card.setAttribute('data-visible', i < visibles ? 'true' : 'false');
    });
    if (botonMas) botonMas.style.display = visibles >= cards.length ? 'none' : '';
    if (botonMenos) botonMenos.style.display = visibles > porPagina ? '' : 'none';
  }

  mostrar();

  if (botonMas) botonMas.addEventListener('click', function () {
    visibles = Math.min(cards.length, visibles + porPagina);
    mostrar();
  });
  if (botonMenos) botonMenos.addEventListener('click', function () {
    visibles = Math.max(porPagina, visibles - porPagina);
    mostrar();
    contenedor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
